import { NavigationBreadcrumbs } from '@telefonica/mistica';
import { ReactEventHandler, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface BreadcrumbsWrapperType {
    breadcrumbs: readonly {
        readonly title: string;
        readonly url: string;
    }[];
    title: string;
}

const BreadCrumbsWrapper = (props: BreadcrumbsWrapperType) => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleNavigation = (e: MouseEvent) => {
            const target = e.target as HTMLAnchorElement;
            if (target.tagName === 'A') {
                e.preventDefault();
                const url = new URL(target.href, window.location.origin);

                if (url) navigate(`${url.pathname}${url.search}`);
            }
        };

        const breadcrumbsElement = document.querySelector('.breadcrumbs-container');

        if (breadcrumbsElement) (breadcrumbsElement as HTMLDivElement).addEventListener('click', handleNavigation);

        return () => {
            if (breadcrumbsElement) {
                (breadcrumbsElement as HTMLDivElement).removeEventListener('click', handleNavigation);
            }
        };
    }, [navigate]);

    return (
        <div className='breadcrumbs-container'>
            <NavigationBreadcrumbs {...props} />
        </div>
    );
};

export default BreadCrumbsWrapper;
